export default {
  ApiErrors: {
    generic:
      'Er is een fout opgetreden. Gelieve de pagina te herladen en contact met ons op te nemen als het probleem aanhoudt.',
    'Email already exists': 'E-mail is al in gebruik',
    'This field is required.': 'Dit veld is verplicht',
    'First_name must be filled': 'Voornaam moet ingevuld worden',
    'Password length must be over 8 characters': 'Wachtwoord moet langer zijn dan 8 tekens',
    'Unable to login with the provided credentials': 'Inloggen met de opgegeven gegevens niet mogelijk',
    'godson is already a customer': 'Dit e-mailadres is al in gebruik door een klant',
    'godson is in referral process': 'Dit e-mailadres zit al in het verwijzingsproces',
    'Enter a valid email address': 'Dit is geen geldig e-mailadres',
    'Email already in db': 'E-mail is al in gebruik',
    'Not an email': 'Ongeldig e-mailadres',
    'Reward is soldout': 'Deze beloning is uitverkocht',
    'Reward can only be claimed once': 'U heeft deze beloning al opgeëist',
    'Reward is no longer valid': 'Deze beloning is niet langer geldig',
    'Not enough points': 'U heeft niet genoeg punten',
    'Account already in use': 'Dit account wordt al door een andere gebruiker gebruikt',
    'This instagram account does not exist on Instagram': 'Dit Instagram-account bestaat niet',
    'social error': "Voer uw account {'@'}mijn_account in",
    'required field': 'Vul dit veld in',
    'value error': 'De ingevoerde waarde is niet correct',
    'You already applied a discount code': 'U heeft al een kortingscode toegepast'
  },
  Error: {
    generic: 'Er is een fout opgetreden, gelieve de pagina te herladen.',
    link: 'Pagina herladen',
    title: 'Loyoly - Oeps! Fout',
    blacklistMessage1: 'U komt niet in aanmerking voor het loyaliteitsprogramma.',
    blacklistMessage2: 'Neem contact op met het ondersteuningsteam als u denkt dat dit een vergissing is.'
  },
  FormEmail: {
    example: "johndoe{'@'}gmail.com",
    errors: {
      email: 'Vul een geldig e-mailadres in',
      emailEmpty: 'Vul je e-mailadres in'
    }
  },
  InApp: {
    message: 'Voor een optimale ervaring, ga naar uw standaardbrowser'
  },
  Phone: {
    countrySelector: {
      placeholder: 'Landcode',
      error: 'Kies een land',
      searchPlaceholder: 'Selecteer een land'
    },
    phoneInput: {
      placeholder: 'Telefoonnummer',
      example: 'Voorbeeld:'
    },
    error: {
      invalid: 'Voer een geldig telefoonnummer in'
    }
  },
  Instagram: {
    ModalNotLinked: {
      title: 'Verbind met mijn Instagram-account',
      subtitle: 'Hoe het werkt',
      description: 'Voer uw Instagram-account in en zorg ervoor dat het openbaar is voordat u de missies uitvoert.',
      form: {
        username: 'Instagram-account',
        usernameExample: "{'@'}johndoe"
      },
      errors: {
        usernameEmpty: 'Voer de naam van uw account in',
        usernameNotFound: 'Voer een geldige accountnaam in'
      },
      button: 'Bevestigen'
    },
    ModalSearching: {
      title: 'We zoeken naar uw account'
    },
    ModalLinked: {
      title: 'Verbind met mijn Instagram-account',
      private: {
        subtitle: 'Verbinding met uw account niet mogelijk',
        description: {
          title: 'Uw Instagram-account is privé',
          text: 'Oeps, het lijkt erop dat uw Instagram-account privé is. Zet het openbaar om toegang te krijgen tot alle missies.'
        }
      },
      public: {
        subtitle: 'Verbinding met uw account succesvol',
        description: {
          title: 'Gefeliciteerd',
          text: 'U kunt nu de missies uitvoeren.'
        }
      },
      buttons: {
        edit: 'Mijn account bewerken',
        retry: 'Opnieuw proberen',
        goback: 'Terug naar de pagina',
        gotoChallenge: 'Ga naar de missie'
      }
    },
    ModalNotFound: {
      title: 'Verbind met mijn Instagram-account',
      subtitle: 'Verbinding met uw account niet mogelijk',
      description: {
        title: 'Account niet gevonden',
        text: 'Verander van account of neem contact op met de support.'
      },
      buttons: {
        change: 'Account veranderen',
        retry: 'Opnieuw proberen'
      }
    }
  },
  Modal: {
    Notifications: {
      title: 'E-mailmeldingen',
      information: {
        title: 'Informatie',
        text: 'Als u geen herinneringen aan missies, nieuws of beloningsherinneringen wilt ontvangen, kunt u zich afmelden door de onderstaande selectievakjes uit te schakelen:'
      },
      communication: {
        optinTransactional: 'Promotie: informatie over het programma, VIP-niveaus, beloningen.',
        optinMarketing: 'Informatief: Informatie over aankopen en sponsoring.'
      }
    },
    SocialAccount: {
      Info: {
        public: 'Openbaar account',
        private: 'Privé-account',
        followers: '<span class="weglot-ignore">{n}</span> volgers | <span class="weglot-ignore">{n}</span> volgers'
      }
    }
  },
  Points: '<span class="weglot-ignore">{n}</span> punt | <span class="weglot-ignore">{n}</span> punten',
  PointsDecimal: '<span class="weglot-ignore">{value}</span> punt | <span class="weglot-ignore">{value}</span> punten',
  SectionHeader: {
    poweredBy: 'Aangedreven door'
  },
  SectionChallenges: {
    empty: 'Er zijn geen missies beschikbaar in uw loyaliteitsprogramma',
    showAll: 'Alles weergeven',
    ModalMissionDetail: {
      description: 'Beschrijving',
      pointsToEarn: 'Te verdienen punten',
      howto: 'Hoe het werkt?',
      uploadMedia: 'Upload uw media',
      reviewApplication: 'Laat een beoordeling achter',
      linkApplication: 'Download de app',
      newsletterPartners:
        'Door op "Missie bevestigen" te klikken, stemt u ermee in commerciële aanbiedingen van het bedrijf elektronisch te ontvangen.',
      phonePartners: 'Ik ga ermee akkoord dat mijn telefoonnummer wordt gebruikt om sms-aanbiedingen te ontvangen.',
      clue: 'Aanwijzing',
      linkPage: 'Bekijk de pagina',
      instaMention: 'Noem',
      tiktokMention: 'Noem',
      instaHashtags: 'Te gebruiken hashtags',
      tiktokHashtags: 'Te gebruiken hashtags',
      linkToShare: 'Link om in uw verhaal te plaatsen',
      linkShare: 'Deel de link',
      vouchertoShare: 'Te delen promotiecode',
      goToAccount: 'Ga naar het account',
      goToInsta: 'Ga naar het account',
      goToInstaPost: 'Ga naar de Instagram-post',
      goToInstaReel: 'Ga naar de Instagram-reel',
      goToInstaIGTV: 'Ga naar de Instagram-IGTV',
      goToTweeterTweet: 'Ga naar de tweet',
      goToReview: 'Laat een beoordeling achter',
      goToShop: 'Ga naar de winkel',
      goToLink: 'Ga naar de pagina',
      goToTypeform: 'Vul het formulier in',
      goToWhatsapp: 'Word lid van groep',
      submit: 'Bevestig de missie',
      missionPendingTitle: 'Missie in verificatie',
      missionPendingExplain: 'Uw punten worden binnenkort bijgeschreven.',
      actionSurveyTextError: 'Selecteer een antwoord',
      actionEmailError: 'Uw e-mail is ongeldig',
      actionInputError: 'Dit veld is ongeldig',
      actionInputImageError: 'Upload uw media',
      handlingMedia: 'Media verwerken',
      errorMediaHandle: 'Er is een fout opgetreden bij het verwerken van uw media',
      imageInvalid: 'Er is een fout opgetreden bij het verwerken van uw media',
      videoSize: 'De grootte van uw video moet minder dan 100 MB zijn.',
      errorInstaReel: 'De URL van uw reel is ongeldig',
      'This url is not a valid google url': 'De URL van uw Google-beoordeling is ongeldig',
      'This url is not a valid reel url': 'De URL van uw reel is ongeldig',
      refusalReasonCondition: 'Niet naleving van de voorwaarden',
      refusalReasonQuality: 'Te lage kwaliteit',
      refusalReasonContent: 'Ongepaste inhoud',
      refusalReasonSound: 'Onhoorbaar geluid',
      missionInvalidTitle: 'Missie ongeldig',
      missionInvalidDescription: 'U kunt de missie opnieuw uitvoeren door de gevraagde regels nauwkeurig te volgen',
      missionInvalidReasons: 'Afwijzingsreden:',
      condition: 'Voorwaarden',
      conditionExplanation: 'Heb meer dan',
      ineligible: 'Niet in aanmerking komend',
      ineligibleExplanation:
        'Het lijkt erop dat u niet het vereiste aantal volgers heeft. Als u meer volgers heeft, werk dan uw accountgegevens bij.',
      lastUpdate: 'Laatste update op',
      updateAccount: 'Mijn account bijwerken',
      reviewLastPurchase: 'Laat een beoordeling achter op de productpagina van uw laatste aankoop',
      whenReviewValidated: 'Zodra de beoordeling is gevalideerd, wordt uw missie automatisch gevalideerd',
      pointsToEarnPhoto: 'Extra punten voor een foto',
      pointsToEarnVideo: 'Extra punten voor een video',
      howtoBirthdate: 'Voer uw geboortedatum in',
      errorInvalidDate: 'Voer een geldige datum in',
      inputMedia: 'Upload uw media',
      inputMediaLoaded: 'Uw media zijn succesvol geüpload',
      placeholderAnswer: 'Schrijf hier uw antwoord',
      misteryAnswer: 'Wat is het mysteriewoord?',
      newsletterEmail: 'Bevestig uw e-mailadres',
      birthDate: 'Geboortedatum',
      example: 'Voorbeeld',
      goToChallenge: 'Ga naar missie'
    },
    ModalMissionImageRights: {
      imageRights:
        'Door dit vakje aan te vinken, bevestig ik dat ik de auteur van de inhoud ben, stem ik uitdrukkelijk in met de overdracht van de bijbehorende intellectuele eigendomsrechten en geef ik toestemming voor het gebruik van mijn afbeelding door het merk voor commerciële doeleinden onder de voorwaarden zoals gespecificeerd in ',
      imageRightsLink: 'deze overeenkomst.',
      title:
        'Overeenkomst inzake overdracht van intellectuele eigendomsrechten op de inhoud en toestemming voor het gebruik van mijn persoonlijke kenmerken.',
      content:
        'Ik ga er uitdrukkelijk mee akkoord dat de publicatie van de inhoud die is gemaakt in het kader van mijn opdracht (de "Inhoud"):',
      bullet1:
        'de overdracht inhoudt, ten gunste van het merk, van alle bijbehorende auteursrechten, wereldwijd en voor de volledige wettelijke duur van het auteursrecht, exclusief en definitief. Ik erken dat deze overdracht wordt verleend als tegenprestatie voor de punten die ik heb verdiend tijdens mijn opdracht, die een eerlijke vergoeding vormen. Deze overdracht omvat het recht van het merk om de Inhoud geheel of gedeeltelijk te reproduceren en te tonen op alle bestaande of toekomstige, voorspelbare of onvoorspelbare dragers en via alle middelen, evenals het recht om de Inhoud te vertalen, bewerken, aanpassen en/of corrigeren, alleen of samen met derden. Ik garandeer dat deze Inhoud geen rechten van derden schendt en geen inbreuk maakt, en vrijwaar het merk hiervoor;',
      bullet2:
        'de toestemming inhoudt die kosteloos aan het merk wordt verleend om mijn met de Inhoud verbonden persoonlijke kenmerken vast te leggen, te reproduceren, te verspreiden en aan het publiek mede te delen, via alle bekende of onbekende, voorspelbare of onvoorspelbare dragers, media, netwerken en verspreidingskanalen, voor doeleinden van exploitatie, informatie, communicatie, promotie en reclame van de producten van het merk, voor een periode van 10 jaar, die indien nodig in onderling overleg kan worden verlengd.',
      end1: 'Deze overeenkomst valt onder het Franse recht en zal dienovereenkomstig worden geïnterpreteerd.',
      end2: 'Eventuele geschillen over de geldigheid, interpretatie of uitvoering van deze overeenkomst vallen onder de exclusieve bevoegdheid van de rechtbanken van Parijs, behoudens andersluidende procedurele regels.'
    },
    ModalMissionLoyaltyDetail: {
      pointsToEarn:
        '<span class="weglot-ignore">{points}</span> punt te verdienen voor elke uitgegeven <span class="weglot-ignore">{amountToPoints}</span> | <span class="weglot-ignore">{points}</span> punten te verdienen voor elke uitgegeven <span class="weglot-ignore">{amountToPoints}</span>',
      orderNumber: 'Bestelling nr',
      orderDate: 'Datum',
      orderAmount: 'Bedrag',
      orderRewardable: 'Beloning',
      orderPoints: 'Verdiende punten',
      orderPaid: 'Bevestigd',
      orderStatus: 'Status',
      orderCancel: 'Terugbetaald',
      orderRefund: 'Gedeeltelijk terugbetaald',
      orderWaiting: 'In afwachting'
    },
    CompanyConditions: {
      seeTermsAndConditions: 'Bekijk de voorwaarden',
      seePrivacy: 'Bekijk de privacy'
    }
  },
  SectionProfile: {
    notificationsByEmails: 'E-mailmeldingen',
    cgu: 'Algemene voorwaarden'
  },
  SectionAccountRewards: {
    empty: 'Er zijn geen beloningen meer om in te wisselen en u heeft geen beloningen in afwachting van gebruik',
    copied: 'Gekopieerd!'
  },
  SectionRewards: {
    empty: 'Er zijn geen beloningen beschikbaar in uw loyaliteitsprogramma',
    showAll: 'Alles weergeven',
    Card: {
      channel_store: 'In de winkel',
      channel_online: 'Online',
      channel_both: 'Online en in de winkel'
    }
  },
  SectionRewardsModalMyRewards: {
    title: 'Mijn beloningen',
    empty: 'U heeft nog geen beloningen.',
    emptyTip: 'U kunt missies uitvoeren en uw gespaarde punten inwisselen voor beloningen',
    use: 'Gebruik',
    expired: 'Verlopen'
  },
  SectionRewardsDetailInfos: {
    expireDate: 'Vervaldatum',
    expirationDelayExplain:
      'De beloning is <span class="weglot-ignore">{expiration_delay}</span> dagen geldig nadat u deze heeft ingewisseld.',
    minimumBuy: 'Minimale aankoop',
    maxAmount: 'Geldig tot',
    description: 'Beschrijving',
    saleChannel: 'Verkoopkanaal',
    channelStore: 'In de winkel',
    channelOnline: 'Online',
    channelBoth: 'Online en in de winkel'
  },
  SectionRewardsDetailModal: {
    exchange: 'Inwisselen',
    errorMessage1: 'Er lijkt een probleem te zijn opgetreden.',
    errorMessage2: 'Uw beloning is niet ingewisseld en uw punten zijn niet afgetrokken.',
    errorMessage3: 'Gelieve de pagina te herladen.',
    errorButton: 'Pagina herladen'
  },
  SectionRewardsClaimModal: {
    howItWorks: 'Hoe het werkt',
    howItWorkCode: 'Gebruik uw code op onze website bij het afrekenen',
    howItWorkCodePOS: 'Presenteer uw code rechtstreeks in de winkel bij het afrekenen.',
    howItWorkCodeCMSPOS:
      'Gebruik uw code op onze website bij het plaatsen van uw bestelling, of presenteer deze rechtstreeks in de winkel bij het afrekenen.',
    howItWorkCodeProduct: 'Voeg het product toe aan uw winkelwagen en gebruik vervolgens de code bij het afrekenen',
    howItWorkCodeRecharge: 'Voeg de code rechtstreeks toe in uw klantportaal',
    howItWorkExt: 'We zullen contact met u opnemen om uw beloning te ontvangen',
    applyToBasket: 'Toepassen op winkelmandje',
    apply: 'Toepassen',
    applied: 'Toegepast',
    link: 'Link naar product',
    copied: 'Gekopieerd!',
    customerPortal: 'Klantenportaal',
    nonApplicable: 'Niet beschikbaar'
  },
  SectionRewardsDetailsRechargeSubscriptions: {
    apply: 'Toepassen',
    nonApplicable: 'Niet beschikbaar',
    itemTitle: '{title} / {price}',
    customerPortal: 'Klantenportaal'
  },
  SectionReferral: {
    friendEmail: 'E-mail van uw vriend',
    seeReferral: 'Bekijk mijn aanbevelingen',
    errors: {
      emailSelf: 'Het ingevoerde e-mailadres is hetzelfde als uw e-mailadres'
    },
    Tabs: {
      link: 'Link',
      email: 'E-mail',
      sms: 'SMS',
      copy: 'Kopieer link',
      smsSend: 'Stuur een bericht',
      reward1: '{amount} punten',
      reward2: '{amount}% korting',
      reward3: '{amount} tegoedbon',
      smsTemplate:
        'Hallo! Ik heb {brand_name} ontdekt die je misschien leuk vindt.\n\n Door mijn verwijzingslink {referral_link} te gebruiken, profiteer je van {reward_friend}.\n\nProfiteer ervan, het is een echt interessante aanbieding!\nTot snel!'
    },
    Modal: {
      emptyState: 'U heeft nog geen aanbevelingen gedaan',
      title: 'Mijn aanbevelingen',
      status: 'Status',
      email: 'E-mail',
      date: 'Vervaldatum',
      statusPending: 'In afwachting',
      statusUsed: 'Reeds gebruikt',
      statusAvailable: 'Beschikbaar',
      statusExpired: 'Verlopen',
      statusInvalidate: 'Ongeldig',
      promocodeComing: 'Komt binnenkort',
      promocodeUnavailable: '-',
      promocodeInvalidate: 'Ongeldig',
      points_given: 'Uw punten zijn bijgeschreven',
      referral_type_3: 'Cadeaubon',
      referral_type_2: 'Promotiecode',
      referral_type_1: 'Punten'
    },
    NotAuthenticatedForm: {
      emailPlaceholder: 'E-mail',
      emailError: 'Het e-mailformaat is niet correct',
      emailEmpty: 'Vul dit veld in',
      emailUnknown: 'Maak een account aan om te kunnen verwijzen'
    }
  },
  SectionVipTiersProgress: {
    you: 'U',
    points: 'punten'
  },
  SectionVipTiersCard: {
    rewardPoints: '{points} punten toegekend',
    rewardMultiplier: 'Puntenvermenigvuldiger: x{multiplier}',

    tiersPoints: '{amount} punten'
  },
  SectionGifting: {
    empty: 'Er zijn momenteel geen producttests beschikbaar',
    showAll: 'Alles weergeven',
    ModalApply: {
      endDate: 'Einddatum voor aanmelding',
      description: 'Beschrijving',
      completeForm: 'Vul het formulier in om uw aanmelding in te dienen',
      button: 'Aanmelden',
      success: {
        title: 'Inschrijving voor producttest',
        description:
          'Bedankt voor het invullen van uw gegevens. Uw aanmelding wordt beoordeeld. U wordt per e-mail op de hoogte gebracht.'
      },
      Form: {
        Errors: {
          required: 'Vul dit veld in',
          date: 'Voer een geldige datum in'
        }
      }
    },
    ModalParticipate: {
      challenges: 'Missies',
      howItWorks: 'Hoe het werkt',
      useCode: 'Gebruik uw code op onze website bij het afrekenen.',
      youWillBeContacted: 'We nemen contact met u op om uw product op te halen.',
      buttonLink: 'Link naar product',
      buttonCopied: 'Gekopieerd!'
    }
  },
  SectionGiftingCardList: {
    status: {
      participate: 'Deelnemen',
      underValidation: 'In verificatie',
      apply: 'Aanmelden',
      ended: 'Beëindigd',
      rejected: 'Aanmelding afgewezen'
    }
  },
  SectionSteps: {
    Authenticated: {
      month: '{n} maand| {n} maanden'
    },
    ModalActivities: {
      title: 'Mijn recente activiteiten',
      empty: 'U heeft nog geen recente activiteiten.',
      table: {
        header: {
          title: 'Titel',
          points: 'Punten',
          date: 'Datum'
        }
      },
      events: {
        challenge: 'Missie gevalideerd',
        order: 'Bestelling geplaatst',
        reward: 'Beloning ontvangen',
        refferal: 'Aanbeveling gevalideerd',
        userAction: 'Punten aangepast',
        level: 'Niveau bereikt',
        levelLabel: 'Niveau {level}',
        reset: 'Verloop van punten',
        automation: 'Punten verdiend'
      }
    }
  },
  Tiktok: {
    ModalNotLinked: {
      title: 'Verbind met mijn TikTok-account',
      subtitle: 'Hoe het werkt',
      description: 'Voer uw TikTok-account in en zorg ervoor dat het openbaar is. U kunt dan TikTok-missies uitvoeren.',
      button: 'Mijn account verbinden'
    },
    ModalLinked: {
      title: 'Verbind met mijn TikTok-account',
      subtitle: 'Verbinding met uw account succesvol',
      congratulations: 'Gefeliciteerd',
      description: 'U kunt nu de missies uitvoeren.',
      buttons: {
        edit: 'Mijn account bewerken',
        goback: 'Terug naar de pagina'
      }
    }
  },
  SectionReferralFriend: {
    placeholder: 'E-mailadres',
    emailError: 'Vul een geldig e-mailadres in',
    emailEmpty: 'Vul je e-mailadres in',
    disclaimer: 'Deze aanbieding is alleen geldig voor nieuwe klanten',
    disclaimerVerification: 'Je wordt niet opnieuw benaderd voor commerciële doeleinden.',
    referral_type_3: 'Cadeaubon',
    referral_type_2: 'Promotiecode',
    referral_type_1: 'Punten',
    copied: 'Gekopieerd!',
    label_optin_reminder: 'Ik wil een herinnering ontvangen als ik mijn korting niet gebruik.',
    btn_optin_reminder: 'Ontvang een herinnering voor mijn code'
  },
  Unsubscribe: {
    title: 'Wil je je echt uitschrijven voor de e-mails van ons loyaliteitsprogramma?',
    description:
      'Als dat het geval is, weet dan dat je geen informatie meer zult ontvangen over je beloningen, missies en punten.',
    email: 'E-mail',
    button: 'Mijn voorkeuren bijwerken',
    question: 'Welk type e-mails wil je ontvangen?',
    optinTransactional: 'Promotie: informatie over het programma, VIP-niveaus, beloningen.',
    optinMarketing: 'Informatief: Informatie over aankopen en sponsoring.',
    successTitle: 'Je voorkeuren zijn bijgewerkt',
    successDescription: 'Gebruik de onderstaande knop om je voorkeuren te bekijken of te wijzigen',
    successButton: 'Mijn voorkeuren bijwerken',
    errorTitle: 'Er is een fout met de doorverwijzingslink',
    errorButton: 'Doorverwijzen naar de website'
  },
  SectionAccount: {
    copied: 'Gekopieerd!'
  },
  SectionPointCard: {
    you: 'U',
    copied: 'Gekopieerd!'
  }
}
